module.exports = __webpack_public_path__ + "static/img/方胜磐石@2x.f83834a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/方胜磐石@2x.png
// module id = g9Ft
// module chunks = 0